import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';
import { TranslateFirebaseService } from './service/utils/translate-firebase.service';

import firebase from "firebase/app";
import "firebase/analytics";
import { environment } from 'src/environments/environment';

import { NavigationEnd, Router } from '@angular/router';
import { UserService } from './models/user/user.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'upservice-frontend';
  _iconPaths : any[] = [];

  constructor(private translateFirebase : TranslateFirebaseService,
    private matIconRegistry: MatIconRegistry,
    private domSanitizer: DomSanitizer,
    private httpClient: HttpClient,
    private userService : UserService,
    public router : Router) {

      //this.setPropertiesFirebase();

    /* this.router.events.subscribe(event => {
        if(this.userService.eliotUser.profiling) this.setPage(event);
      }); */

      this.setIcons();
  }

  /* private setPage(event:any){
    if (event instanceof NavigationEnd) {
      firebase.analytics().logEvent('page_view' ,  { page_location: event.urlAfterRedirects , page_path: event.urlAfterRedirects , page_title:  event.urlAfterRedirects });
    }
  }

  private setPropertiesFirebase() {
    firebase.analytics();
    firebase.analytics().setUserProperties({environment: environment.environment, version: environment.version});
  } */

  private setIcons() {

    this.getIconsPaths()
    .subscribe(result => {
      this._iconPaths = result;
      this.addIcons();
    });
  }

  private getIconsPaths() : Observable<any> {
    return this.httpClient.get("assets/icons/content.json");
  }

  private addIcons(){
    this._iconPaths.forEach(element => {
      this.matIconRegistry.addSvgIcon(
        element.icon,
        this.domSanitizer.bypassSecurityTrustResourceUrl(element.path)
      );
    });
  }

}
